import React from "react";
import SearchBox from "./SearchBox";
import appContext from "../../appContext";
import SortIcon from "@mui/icons-material/Sort";
import FilterListIcon from "@mui/icons-material/FilterList";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import CustomizedSingleSelectDropdown from "../../components/CreateForm/DropdownBase";

import { sidebarValueConstants } from "./sidebarutils";
import {
  CreateNewFormButton,
  DeleteForeverButton,
} from "../../components/Custom/Buttons";

import {
  Application,
  Department,
  filterByOptions,
  sortByOptions,
  sortByDate,
} from "../../Utils/common";

import {
  ActionsGridContainer,
  CreateNewButtonContainer,
  FilterBoxContainer,
  HeaderActionsContainer,
  HeaderContainer,
  HeaderTitleContainer,
  LabelContainer,
  SearchBoxContainer,
} from "./styled";

export default function WorkspaceHeader({
  setLoading,
  sortOption,
  setSortOption,
  sortByDateOption,
  setSortByDateOption,
  filterOption,
  setFilterOption,
  filterValue,
  setFilterValue,
  searchValue,
  setSearchValue,
  selectedMode,
  deleteForeverClickHandler,
  isLoading,
  setCreateNewFormPopup
}: any) {
  const { isListEmpty, isListSearchActive } = React.useContext(appContext);

  const isLessThan1280 = useMediaQuery("(max-width:1279px)");
  const isLessThan1350 = useMediaQuery("(max-width:1350px)");
  const isLessThan1450 = useMediaQuery("(max-width:1450px)");
  const isLessThan1550 = useMediaQuery("(max-width:1550px)");
  const isLessThan1750 = useMediaQuery("(max-width:1750px)");

  const marginRightSpace = React.useMemo(() => {
    const isDateSort = (sortOption === "newest" || sortOption === "oldest");
    if (isLessThan1350) {
      return "10px";
    }

    if (isLessThan1450) {
      return "5%";
    }

    if (isLessThan1750) {
      return isDateSort ? "5%" : "10%";
    }

    return isDateSort ? "10%" : "15%";
  }, [isLessThan1350, isLessThan1450, isLessThan1750, sortOption]);

  const renderLabel = (label: string) => {
    if (isLessThan1550) {
      return <React.Fragment />;
    }

    return <LabelContainer>{label}</LabelContainer>;
  };

  const handleOnSearchChange = (value: string) => {
    value.length === 0 && setLoading(true);
    filterOption === "formName" ? setSearchValue(value) : setFilterValue(value);
  };

  const handleOnClear = () => {
    setLoading(true);
    filterOption === "formName" ? setSearchValue("") : setFilterValue("");
  };

  const renderSortDropDown = () => {
    const isDateSort = (sortOption === "newest" || sortOption === "oldest");
    return (
      <FilterBoxContainer marginRightSpace={isDateSort ? "10px" : marginRightSpace}>
        {renderLabel("Sort by")}
        <CustomizedSingleSelectDropdown
          value={sortOption}
          setValue={setSortOption}
          dataProvider={sortByOptions}
          startAdornment={isLessThan1550 ? <SortIcon fontSize="small" /> : null}
        />
      </FilterBoxContainer>
    );
  };

  const renderSortByDateDropDown = () => {
    return (
      <FilterBoxContainer marginRightSpace={marginRightSpace}>
        <CustomizedSingleSelectDropdown
          value={sortByDateOption}
          setValue={setSortByDateOption}
          dataProvider={sortByDate}
          startAdornment={isLessThan1550 ? <FilterListIcon fontSize="small" /> : null}
        />
      </FilterBoxContainer>
    );
  };

  const renderFilterDropDown = () => {
    return (
      <FilterBoxContainer marginRightSpace={marginRightSpace}>
        {renderLabel("Filter by")}
        <CustomizedSingleSelectDropdown
          value={filterOption}
          setValue={setFilterOption}
          dataProvider={filterByOptions}
          startAdornment={
            isLessThan1550 ? <FilterListIcon fontSize="small" /> : null
          }
        />
      </FilterBoxContainer>
    );
  };

  const renderSearchBox = () => {
    if (filterOption === "formName" || filterOption === "UseCase") {
      return (
        <SearchBoxContainer isSmallScreen={isLessThan1280}>
          <SearchBox
            placeHolder="Search form templates"
            value={filterOption === "formName" ? searchValue : filterValue}
            setValue={handleOnSearchChange}
            clearHandler={handleOnClear}
          />
        </SearchBoxContainer>
      );
    }

    return (
      <SearchBoxContainer isSmallScreen={isLessThan1280}>
        <CustomizedSingleSelectDropdown
          value={filterValue}
          setValue={setFilterValue}
          startAdornment={
            isLessThan1550 ? (
              <InfoOutlinedIcon fontSize="small" />
            ) : (
              <React.Fragment />
            )
          }
          dataProvider={
            filterOption === "Application" ? Application : Department
          }
        />
      </SearchBoxContainer>
    );
  };

  const renderCreateButton = () => {
    return (
      <CreateNewFormButton
        onClick={() => setCreateNewFormPopup(true)}
      />
    );
  };
  const renderDeleteButton = () => {
    return (
      <DeleteForeverButton
        disabled={isListEmpty}
        onClick={deleteForeverClickHandler}
      />
    );
  };

  const renderHeaderActions = () => {
    return (
      <HeaderActionsContainer>
        {/* {!isLoading && (
          <> */}
        <ActionsGridContainer container>
          {renderSortDropDown()}
          {(sortOption === "newest" || sortOption === "oldest") && renderSortByDateDropDown()}
          {renderFilterDropDown()}
          {renderSearchBox()}
        </ActionsGridContainer>
        <CreateNewButtonContainer container>
          {selectedMode === sidebarValueConstants.deleted
            ? renderDeleteButton()
            : renderCreateButton()}
        </CreateNewButtonContainer>
        {/* </>
        )} */}
      </HeaderActionsContainer>
    );
  }


  return (
    <HeaderContainer
      isSmallScreen={isLessThan1280}
      isListEmpty={isListEmpty && !isListSearchActive}
    // className={isListEmpty && !isListSearchActive ? "flex_style" : ""}
    >
      <HeaderTitleContainer isSmallScreen={isLessThan1280}>
        My Conversational Forms
      </HeaderTitleContainer>
      {renderHeaderActions()}
    </HeaderContainer>
  );
}
